import { ExternalLink } from "lucide-react";
import { Badge, cn } from "@fox1ck-org/ui";
import type { Campaign } from "@gen/tracker/v1/campaign_pb";

import { useT } from "@/lib/i18n";

/** The campaign is another block's and that block holds the pen: every write is refused (`locked_by_source`). Pure. */
export function lockedBySource(campaign: Campaign | undefined): boolean {
  return !!campaign?.importedFrom?.locked;
}

/**
 * «Импорт · {label}» and «Управлять» (the source's own screen, a new tab) —
 * beside a campaign's name wherever it is drawn: the list's row, the card's
 * and the editor's title. Nothing when the campaign is the tracker's own.
 */
export function ImportedBadge({ campaign, size, className }: { campaign: Campaign | undefined; size?: "sm"; className?: string }) {
  const t = useT();
  const from = campaign?.importedFrom;
  if (!from) return null;
  return (
    <span className={cn("flex shrink-0 items-center gap-1.5", className)}>
      <Badge variant="info" size={size}>
        {t("camps.badge.imported", { label: from.label })}
      </Badge>
      {from.manageUrl ? (
        <a
          href={from.manageUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
          className="flex items-center gap-1 text-xs text-primary hover:underline"
        >
          {t("camps.import.manage")}
          <ExternalLink className="size-3" strokeWidth={1.5} />
        </a>
      ) : null}
    </span>
  );
}

/** «Кампания управляется в {label} — изменения там»: why the card's and the editor's writes are off. */
export function LockedNote({ campaign, className }: { campaign: Campaign | undefined; className?: string }) {
  const t = useT();
  if (!lockedBySource(campaign)) return null;
  return <p className={cn("text-caption", className)}>{t("camps.import.locked", { label: campaign!.importedFrom!.label })}</p>;
}
